module.exports = __webpack_public_path__ + "static/media/hcm_old.7784a4f5.jpg";